import { render, staticRenderFns } from "./IBtn.vue?vue&type=template&id=4fe156ce"
import script from "./IBtn.vue?vue&type=script&lang=js"
export * from "./IBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports